import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function usePodcastSubscriptions(data = {}) {
  const { enabled = false, params = {} } = data;
  const { privateFetch } = useContext(FetchContext);

  const getSubscriptions = () =>
    privateFetch.get('/v1/admin/podcast-billing/subscriptions', { params });

  return useQuery(['podcast-subscriptions-list', params], getSubscriptions, {
    enabled,
    keepPreviousData: true,
  });
}

export default usePodcastSubscriptions;
